const t="X-Danfoss-Segment",e="Authorization",n="Accept-Language";export{n as ACCEPT_LANGUAGE_HEADER,e as AUTHORIZATION_HEADER,t as X_DANFOSS_SEGMENT_HEADER};
